<template>
  <v-container v-if="this.prestacaoConta" fluid class="docs mt-4">
    <v-row>
      <v-col cols="12">
        <v-card tile class="mx-1">
          <v-stepper value="1">
            <v-stepper-header>
              <v-stepper-step step="1" :complete="this.numeroStatus[this.prestacaoConta.status] > 1">
                Prestação de Contas Financeira
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2" :complete="this.numeroStatus[this.prestacaoConta.status] > 2">
                Relatório de Monitoramento Financeiro
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" :complete="this.numeroStatus[this.prestacaoConta.status] > 3">
                Manifestação da OSC
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="4" :complete="this.numeroStatus[this.prestacaoConta.status] > 4">
                Posição Comissão da Requerente
              </v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </v-card>
      </v-col>
      
      <PrestacaoCard :prestacaoConta="prestacaoConta" :papeis="papeis"></PrestacaoCard>

      <MonitoramentoCard :prestacaoConta="prestacaoConta" :papeis="papeis"></MonitoramentoCard>
      
      <ManifestacaoCard :prestacaoConta="prestacaoConta" :papeis="papeis"></ManifestacaoCard>      

      <v-col cols="12">
        <ParecerCard :prestacaoConta="prestacaoConta" :papeis="papeis"></ParecerCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import asyncDataStatus from "@/mixins/asyncDataStatus";
import PrestacaoCard from "../prestacao/PrestacaoCard"
import MonitoramentoCard from "../monitoramento/MonitoramentoCard"
import ManifestacaoCard from "../manifestacao/ManifestacaoCard"
import ParecerCard from "../parecer/ParecerCard"


export default {
  components: {
    PrestacaoCard,
    MonitoramentoCard,
    ManifestacaoCard,
    ParecerCard
  },
  mixins: [asyncDataStatus],
  computed: {
    prestacaoConta() {
      return this.$store.getters["prestacaoConta/byId"](
        parseInt(this.$route.params.prestacaoContaId)
      );
    },

    papeis() {
      var payload = {
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.$store.getters["usuario/getUsuarioAutenticado"].id,
      }      
      return this.$store.getters["projeto/getPapeisParticipante"](payload);
    }
  },

  data() {
    return {
      numeroStatus: {
        'ABERTO': 1,
        'AGUARDANDO_MONITORAMENTO': 2,
        'AGUARDANDO_MANIFESTACAO': 3,
        'AGUARDANDO_PARECER': 4,
        'FINALIZADO': 5,
      }
    };
  },
  methods: {
    ...mapActions("prestacaoConta", ["fetchPrestacaoContaById"]),

    formatDate(data) {
      if (!data) return null

      const [ano, mes, dia] = data.split('-')
      return `${dia}/${mes}/${ano}`
    }, 
  },
  created() {
    var payload = {
      projetoId: this.$route.params.projetoId, 
      prestacaoContaId: this.$route.params.prestacaoContaId
    }
    
    Promise.all([this.fetchPrestacaoContaById(payload),]).then(() => {
      this.asyncDataStatus_fetched();
    });

  },
};
</script>

<style src="./PrestacaoContaDetalhes.scss" lang="scss"/>
